import { render, staticRenderFns } from "./InfraAdjacencyGraphWrapper.vue?vue&type=template&id=589c3788&"
import script from "./InfraAdjacencyGraphWrapper.vue?vue&type=script&lang=js&"
export * from "./InfraAdjacencyGraphWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports